module.exports = __webpack_public_path__ + "media/images/noticias/correo-cf199cc331b3edf8d44d5b02fa30a19e.png";